import {AfterViewChecked, Component, DOCUMENT, ElementRef, HostListener, Inject, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {RoutingService} from '@spartacus/core';
import {KeyboardFocusService, StorefrontComponent} from '@spartacus/storefront';

import {AimoHamburgerMenuService} from '../hamburger-menu/aimo-hamburger-menu.service';
import {AimoUxTypeService} from "../../service/general/aimo-ux-type.service";
import {Observable} from "rxjs";

@Component({
    selector: 'aimo-cx-storefront',
    templateUrl: './aimo-storefront.component.html',
    standalone: false
})
export class AimoStorefrontComponent extends StorefrontComponent implements AfterViewChecked, OnInit {
    constructor(
        hamburgerMenuService: AimoHamburgerMenuService,
        routingService: RoutingService,
        protected elementRef: ElementRef<HTMLElement>,
        protected keyboardFocusService: KeyboardFocusService,
        @Inject(DOCUMENT) protected document: Document,
        protected router: Router,
        protected aimoUxTypeService: AimoUxTypeService
    ) {
        super(hamburgerMenuService, routingService, elementRef, keyboardFocusService);
        this.isMobileApp$ = this.aimoUxTypeService.isMobileApp();
    }

    testEnvironments = ['test-shop', 'test-my'];
    // eslint-disable-next-line
    private tokenExpirationTimer: any;
    isMobileApp$: Observable<boolean>;
    showHeader: boolean = true;

    private hiddenHeaderUrls = ['/cart', '/p/', '/ordertemplates', '/favorites'];

    ngAfterViewChecked(): void {
        this.addIfTestEnvironment();
        this.showHeader = !this.hiddenHeaderUrls.some(url => this.document.location.href.includes(url));
    }

    addIfTestEnvironment(): void {
        // if (this.testEnvironments.some(testEnvironment => this.aWinRef.location.hostname.includes(testEnvironment))) {
        //   // There's at least one
        //   const siteLogo = document.getElementById('header-area').querySelector('.header > .SiteLogo');
        //   if (siteLogo && !siteLogo.querySelector('#testParagraph')) {
        //     const paragraph = document.createElement('h4');
        //     paragraph.setAttribute('id', 'testParagraph');
        //     paragraph.innerHTML = 'Test';
        //     siteLogo.append(paragraph);
        //   }
        // }
    }

    // clickout logic added to original NavigationUIComponent
    @HostListener('document:click', ['$event'])
    clickout(event): void {
        const element = event.target;
        const parentElement = (<HTMLElement>event.target)?.closest('cx-page-layout.navigation');
        if (
            element.nodeName.toLowerCase() === 'header' &&
            element.className.includes('is-expanded') &&
            !parentElement
        ) {
            this.collapseMenu();
        }
    }

    @HostListener('window:scroll', []) // for window scroll events
    onScroll(): void {
        this.stickyNavigationObserver();
    }

    stickyNavigationObserverInited = false;

    stickyNavigationObserver(): void {
        if (this.stickyNavigationObserverInited) {
            return;
        }
        this.stickyNavigationObserverInited = true;
        const header = <HTMLElement>this.document.querySelector('.sticky-header');
        const observer = new IntersectionObserver(
            ([e]) => e.target.classList.toggle('is-pinned', e.intersectionRatio < 1),
            {threshold: [1]},
        );
        observer.observe(header);
    }
}
